const HEADER_SELECTOR = '.header';

/**
 * Current rendered height of the sticky header, measured on demand so it stays
 * correct across breakpoints and when the mobile menu wraps
 *
 * @returns {number} Header height in pixels, or 0 if no header is present
 */
function getHeaderHeight() {
  const header = document.querySelector(HEADER_SELECTOR);

  return header ? header.offsetHeight : 0;
}

/**
 * Smooth-scroll the page so the given element sits just below the header
 *
 * @param {Element} target Element to scroll into view
 */
function scrollToTarget(target) {
  const top = target.getBoundingClientRect().top + window.scrollY - getHeaderHeight();

  window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
}

/**
 * Bind smooth scrolling to every same-page anchor (e.g. #contact, #open-roles)
 *
 * Updates the URL hash on click so the address bar reflects the active anchor.
 */
export function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    const hash = link.getAttribute('href');

    if (!hash || hash === '#') {
      return;
    }

    const target = document.querySelector(hash);

    if (!target) {
      return;
    }

    link.addEventListener('click', (e) => {
      e.preventDefault();
      scrollToTarget(target);

      history.pushState(null, '', hash);

      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }

      target.focus({ preventScroll: true });
    });
  });
}
